import { CookieKey, coreNativeModule } from '../types/RNCoreNativeModule';

// DO NOT USE THIS FUNCTION DIRECTLY. USE provider specific setter instead.
function setCookies<K extends CookieKey>(
    cookies: Array<{ name: K; value: string }>,
): Promise<void> {
    const moduleRef = coreNativeModule();
    return moduleRef?.setCookies?.(cookies) ?? Promise.resolve();
}

const JOBSEEKER_WRITEABLE_COOKIES = [CookieKey.referral, CookieKey.stealthGroups] as const;

const _VIEWJOB_WRITEABLE_COOKIES = [
    ...JOBSEEKER_WRITEABLE_COOKIES,
    // MAGUA app download promo frequency control cookies
    CookieKey.maguaSuppressG1T,
    CookieKey.maguaPageVisitsCount,
    CookieKey.maguaPromoShownInSessionCount,
    CookieKey.maguaPromoShownInMonthOrWeekCount,
    CookieKey.maguaPromoClosedInSessionCount,
    CookieKey.maguaPromoClosedInMonthCount,
];
export type ViewJobWriteableCookies = (typeof _VIEWJOB_WRITEABLE_COOKIES)[number];

export function setCookiesForViewJob(
    cookies: Array<{ name: ViewJobWriteableCookies; value: string }>,
): Promise<void> {
    return setCookies(cookies);
}
